import React from 'react';
import GridContainer from "common/components/Grid/GridContainer.jsx";
import GridItem from "common/components/Grid/GridItem.jsx";
import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardFooter.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "common/components/CustomButtons/Button.jsx";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px",
    fontSize: "18px",
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    ...importedStyle.cardIconTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
  labelHorizontal: {
    justifyContent: "center",
    fontSize: "15px",
  },
  outerContainer: {
    marginLeft: "5px",
    marginTop: "20px",
  },
  innerContainer: {
    marginBottom: "20px",
    cursor: "pointer",
  },
  editButton: {
    justifyContent: "center"
  },
};

const MultiItemFormSummary = (props) => {
  const filteredNames = props.myProps.filter(prop => !prop.disabled);
  const propNames = filteredNames.map(prop => prop.propName);
  const title = props.title;
  const schema = props.pathids.getSchema();

  const { classes } = props;
  const Icon = props.icon;

  function getContent(propName) {
    switch (props.pathids.getSchema()[propName].type) {
      case 'bo':
        if (props.pathids.getData(propName, "value")) {
          return "On";
        } else {
          return "Off";
        }
      default:
        if (propName.includes("password")) {
          return "********";
        } else {
          return props.pathids.getData(propName, "display");
        }
    }
  }
  return (
    <>
      <GridContainer justify="center">
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Icon />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>{title}</h4>
            </CardHeader>
            <CardBody>
              <GridContainer
                className={classes.outerContainer}
                alignItems="center"
              >

                {propNames.map((propName, i) => (
                  <GridItem key={i} xs={12}>
                    <div className={classes.innerContainer}>
                      <GridContainer alignItems="center">
                        <GridItem xs={6}>
                          <FormLabel className={classes.labelHorizontal}>
                            {schema[propName].label}
                          </FormLabel>
                        </GridItem>
                        <GridItem xs={6}>
                          <h5 className={classes.datainfo}>
                            {getContent(propName)}
                          </h5>
                        </GridItem>
                      </GridContainer>
                    </div>
                  </GridItem>
                ))}
              <GridItem xs={12}>
                  <div className={classes.innerContainer}>
                    <GridContainer alignItems="center">
                      <GridItem xs={12}>
                      <Button
                        className={classes.editButton}
                        color="primary"
                        onClick={props.openDialog}>
                        Edit
                        </Button>
                      </GridItem>
                    </GridContainer>
                  </div>
                </GridItem>
                </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
export default withStyles(styles)(MultiItemFormSummary);